import React from 'react';
import { cn } from '../../utils/cn';
import Button from '../ui/Button';
import Section from '../layout/Section';

const CTASection = ({
  title,
  description,
  primaryCTA,
  secondaryCTA,
  backgroundClass = 'bg-gradient-to-r from-gray-900 to-blue-900',
  textColor = 'text-white',
  className = '',
  disclaimer,
  ...props
}) => {
  return (
    <Section
      className={cn(backgroundClass, textColor, className)}
      padding="py-20"
      {...props}
    >
      <div className="max-w-4xl mx-auto text-center">
        {title && (
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-heading">
            {title}
          </h2>
        )}
        
        {description && (
          <p className={cn(
            'text-xl mb-8 leading-relaxed',
            textColor === 'text-white' ? 'text-white' : 'text-gray-700'
          )}>
            {description}
          </p>
        )}
        
        {(primaryCTA || secondaryCTA) && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {primaryCTA && (
              <Button
                variant="default"
                size="lg"
                className="px-8 py-4 bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
                {...primaryCTA}
              >
                {primaryCTA.text}
              </Button>
            )}
            
            {secondaryCTA && (
              <Button
                variant="outline"
                size="lg"
                className="px-8 py-4 border-2 border-white bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"
                {...secondaryCTA}
              >
                {secondaryCTA.text}
              </Button>
            )}
          </div>
        )}
        
        {disclaimer && (
          <div className={cn(
            'mt-8 text-sm',
            textColor === 'text-white' ? 'text-white/80' : 'text-gray-600'
          )}>
            <p>{disclaimer}</p>
          </div>
        )}
      </div>
    </Section>
  );
};

export default CTASection;